<template>
    <div class="scc-container">
        <footer class="scc-app-footer-alternative">
            <div class="scc-app-footer-alternative__main-container">
                <div class="scc-app-footer-alternative__container scc-app-footer-alternative__container--flex">
                    <img v-if="gameLogo" class="scc-app-footer-alternative__game-logo" :src="gameLogo" alt="Logo" />
                    <img
                        v-else-if="themeLogo"
                        class="scc-app-footer-alternative__game-logo"
                        :src="themeLogo | cdn({ width: 80, height: 80 })"
                    />
                    <p v-else class="scc-app-footer-alternative__game-logo--fallback"></p>
                </div>
                <div v-if="!excludeLinks" class="scc-app-footer-alternative__container">
                    <div v-if="links && links.length > 0" class="scc-app-footer-alternative__links">
                        <div v-for="(link, i) in links" :key="i" class="scc-app-footer-alternative__link">
                            <p class="scc-app-footer-alternative__link-text">
                                <SccLink :key="link.link" :to="link.link">
                                    {{ link.name }}
                                </SccLink>
                            </p>
                        </div>
                    </div>
                </div>
                <div v-if="!excludeLinks" class="scc-app-footer-alternative__container">
                    <p class="scc-app-footer-alternative__social-heading">{{ shareSentence }}</p>
                    <div class="scc-app-footer-alternative__socials">
                        <ShareNetwork
                            network="facebook"
                            :title="shareTitle"
                            :description="shareDescription"
                            :url="shareUrl"
                        >
                            <FacebookIcon />
                        </ShareNetwork>
                        <ShareNetwork
                            network="twitter"
                            :title="shareTitle"
                            :description="shareDescription"
                            :url="shareUrl"
                        >
                            <TwitterIcon />
                        </ShareNetwork>
                        <ShareNetwork
                            network="linkedin"
                            :title="shareTitle"
                            :description="shareDescription"
                            :url="shareUrl"
                        >
                            <LinkedinIcon />
                        </ShareNetwork>
                        <ShareNetwork network="whatsapp" title="" :description="shareDescription" :url="shareUrl">
                            <WhatsappIcon />
                        </ShareNetwork>
                    </div>
                </div>
                <div
                    v-if="excludeLinks"
                    class="scc-app-footer-alternative__container scc-app-footer-alternative__container--half-width"
                >
                    <p>{{ takeoverSentence }}</p>
                </div>
                <div
                    class="scc-app-footer-alternative__container"
                    :class="`${logos.length === 0 ? 'scc-app-footer-alternative__container--flex' : ''}`"
                >
                    <p
                        class="scc-app-footer-alternative__logos-heading"
                        :class="`${excludeLinks ? 'scc-app-footer-alternative__logos-heading--excluded' : ''}`"
                    >
                        {{ noticeSentence }}
                    </p>
                    <div v-if="logos.length !== 0" class="scc-app-footer-alternative__logos">
                        <template v-for="(logo, i) in logos">
                            <SccLink v-if="logo.link" :key="i" :to="logo.link">
                                <img :src="logo.image" alt="Logo" />
                            </SccLink>
                            <img v-else :key="i" :src="logo.image" alt="Logo" />
                        </template>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import './app-footer-alternative.scss';
import WhatsappIcon from '../../assets/icons/whatsapp.vue';
import FacebookIcon from '../../assets/icons/facebook.vue';
import LinkedinIcon from '../../assets/icons/linkedin.vue';
import TwitterIcon from '../../assets/icons/twitter.vue';

import SccLink from '../global/SccLink';

export default {
    name: 'AppFooterAlternative',
    components: { WhatsappIcon, FacebookIcon, LinkedinIcon, TwitterIcon, SccLink },
    __editor: {
        requiredData: ['themeSettings', 'game'],
        fields: {
            links: {
                widget: 'array',
                values: {
                    flat: false,
                    fields: {
                        name: {
                            widget: 'text',
                        },
                        link: {
                            widget: 'text',
                        },
                    },
                },
            },
            logos: {
                widget: 'array',
                values: {
                    flat: false,
                    fields: {
                        image: {
                            widget: 'text',
                        },
                        link: {
                            widget: 'text',
                        },
                    },
                },
            },
            gameLogo: {
                widget: 'text',
            },
            excludeLinks: {
                widget: 'checkbox',
            },
            takeoverSentence: {
                widget: 'text',
            },
            shareSentence: {
                widget: 'text',
            },
            noticeSentence: {
                widget: 'text',
            },
        },
    },
    props: {
        themeSettings: {
            type: Object,
        },
        game: {
            type: Object,
        },
        links: {
            type: Array,
            default() {
                return [
                    {
                        name: 'Veelgestelde vragen',
                        link: 'veelgestelde-vragen',
                    },
                    {
                        name: 'Deelnemersreglement',
                        link: 'deelnemersreglement',
                    },
                ];
            },
        },
        gameLogo: {
            type: String,
        },
        text: {
            type: String,
            default: '',
        },
        logos: {
            type: Array,
            default: () => [],
        },
        excludeLinks: {
            type: Boolean,
            default: false,
        },
        takeoverSentence: {
            type: String,
            default: '',
        },
        shareSentence: {
            type: String,
            default: '',
        },
        noticeSentence: {
            type: String,
            default: '',
        },
    },
    computed: {
        shareUrl() {
            return window.location.protocol + '//' + window.location.host;
        },
        shareTitle() {
            return `Doe mee met de ${this.game?.name || 'loterij'} en win!`;
        },
        shareDescription() {
            return `Doe mee met de ${this.game?.name || 'loterij'} en steun ons!
            Met je deelname maak je bovendien kans op geweldige prijzen!`;
        },
        themeLogo() {
            return this.themeSettings?.logo || '';
        },
    },
};
</script>
